// extracted by mini-css-extract-plugin
export default {"reportsPage":"ReportsPage_reportsPage__SONC9"};